import Vue from "vue";
import Router from "vue-router";
import Cookies from 'js-cookie'
import { getInfo } from '@/api/login'
Vue.use(Router)

// 无需登录即可访问的路由
const publicPaths = ['/', '/register','/detail','/newsList']

let router = new Router({
	// mode: 'history',
	routes: [{
			path: '/register',
			name: '注册',
			component: () => import('@/views/register/register.vue')
		},
		{
			path: '/',
			name: 'index',
			component: () => import('@/views/index/index.vue')
		},
		{
			path: '/training',
			name: '我的培训',
			meta: { requireAuth: true },
			component: () => import('@/views/training/training.vue')
		},
		{
			path: '/videoDetail',
			name: '播放列表',
			meta: { requireAuth: true },
			component: () => import('@/views/training/videoDetail.vue')
		},
		{
			path: '/printLog',
			name: '打印记录',
			meta: { requireAuth: true },
			component: () => import('@/views/printLog/printLog.vue')
		},
		{
			path: '/BasicInformation',
			name: '我的档案',
			meta: { requireAuth: true },
			component: () => import('@/views/BasicInformation/BasicInformation.vue')
		},
		{
			path: '/detail',
			name: '新闻详情',
			component: () => import('@/views/news/detail.vue')
		},
		{
			path: '/newsList',
			name: '新闻列表',
			component: () => import('@/views/news/list.vue')
		}
	]
})

router.beforeEach((to, from, next) => {
	if (publicPaths.includes(to.path)) {
		next()
		return
	}
	const jsessionid = Cookies.get('JSESSIONID')
	if (!jsessionid) {
		next('/')
		return
	}
	getInfo().then(res => {
		if (res.code === 200) {
			next()
		} else {
			Cookies.remove('JSESSIONID')
			next('/')
		}
	}).catch(() => {
		next('/')
	})
})

export default router;